// Helpers
import { downloadImageFromUrl } from 'helpers/download';
// Ui3
import Button from 'ui3/Button/Button';
// Styles
import styles from './DownloadPoster.module.scss';

type DownloadPosterProps = {
  posterName: string;
  posterImageURL: string;
};

const DownloadPoster = ({
  posterName,
  posterImageURL,
}: DownloadPosterProps) => {
  const handleDownloadPoster = () => {
    downloadImageFromUrl(posterImageURL);
  };

  return (
    <div className={styles.root}>
      <img
        className={styles.posterImage}
        alt={posterName}
        src={posterImageURL}
      />

      <Button
        type="button"
        variant="secondary"
        size="medium"
        icon="download"
        block
        className={styles.downloadButton}
        onClick={handleDownloadPoster}
      >
        Download Poster
      </Button>
    </div>
  );
};

export default DownloadPoster;
